document.addEventListener('DOMContentLoaded', function () {

  const productRoot = document.querySelector('product-info');

  if (!productRoot) return;

  const jsonElement =
    productRoot.querySelector('script[id^="ProductJson-"]');

  if (!jsonElement) return;

  let product;

  try {
    product = JSON.parse(jsonElement.textContent);
  } catch (e) {
    console.warn('PagePilot/Kbite: product JSON could not be read.');
    return;
  }

  if (!product || !Array.isArray(product.variants)) return;

  const variantRadios = productRoot.querySelectorAll(
    '.pp-variant-picker input[type="radio"]'
  );

  /*
   * --------------------------------------------------------
   * 1. MAKE SOLD-OUT OPTIONS CLICKABLE
   * --------------------------------------------------------
   *
   * PagePilot disables them by default.
   *
   * Only do this automatically for products with one option
   * such as Flavor, Size, Colour etc.
   */

  const optionGroups = new Set(
    Array.from(variantRadios).map(input => input.name)
  );

  if (optionGroups.size === 1) {

    variantRadios.forEach(function (input) {

      if (input.disabled) {
        input.disabled = false;
        input.setAttribute('data-out-of-stock-option', 'true');
      }

    });

  }


  /*
   * Find the actual selected Shopify variant
   */

  function getSelectedVariant() {

    const selectedOptions = Array.from(
      productRoot.querySelectorAll(
        '.pp-variant-picker input[type="radio"]:checked'
      )
    ).map(input => input.value);

    return product.variants.find(function (variant) {

      return variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });

    });

  }


  /*
   * --------------------------------------------------------
   * 2. NOTIFY THIRD-PARTY APPS ABOUT VARIANT CHANGE
   * --------------------------------------------------------
   */

  function notifyApps(variant) {

    if (!variant) return;

    const variantIdInput =
      productRoot.querySelector(
        'form[action*="/cart/add"] input[name="id"]'
      ) ||
      productRoot.querySelector('input[name="id"]');


    /*
     * Make absolutely sure Shopify's hidden variant ID
     * contains the currently selected variant.
     */

    if (variantIdInput) {

      variantIdInput.value = variant.id;

      variantIdInput.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );

      variantIdInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

    }


    /*
     * PagePilot uses replaceState(), which doesn't fire
     * popstate automatically.
     *
     * Some third-party apps monitor URL/history changes.
     */

    try {

      window.dispatchEvent(
        new PopStateEvent('popstate', {
          state: history.state
        })
      );

    } catch (e) {

      window.dispatchEvent(
        new Event('popstate')
      );

    }


    /*
     * Broadcast several commonly-used variant events.
     *
     * This doesn't modify PagePilot itself.
     */

    const detail = {
      variant: variant,
      product: product,
      variantId: variant.id,
      sectionId: productRoot.dataset.section
    };

    [
      'variant:change',
      'variantChange',
      'product:variant-change'
    ].forEach(function (eventName) {

      productRoot.dispatchEvent(
        new CustomEvent(eventName, {
          bubbles: true,
          detail: detail
        })
      );

      document.dispatchEvent(
        new CustomEvent(eventName, {
          detail: detail
        })
      );

    });

  }


  /*
   * --------------------------------------------------------
   * 3. LISTEN TO PAGEPILOT VARIANT SELECTION
   * --------------------------------------------------------
   */

  variantRadios.forEach(function (radio) {

    radio.addEventListener('change', function () {

      /*
       * PagePilot also has a change listener.
       * Give PagePilot time to update price/button/URL first.
       */

      setTimeout(function () {

        const variant = getSelectedVariant();

        if (!variant) return;

        notifyApps(variant);

        console.log(
          'PagePilot/Kbite variant:',
          variant.id,
          variant.available ? 'IN STOCK' : 'OUT OF STOCK'
        );

      }, 50);

    });

  });

  /*
 * ========================================================
 * PRODUCT-LEVEL NOTIFY CTA
 * Show whenever ANY variant is unavailable.
 * ========================================================
 */

const soldOutVariants = product.variants.filter(function (variant) {
  return !variant.available;
});

if (soldOutVariants.length) {
  createAnySoldOutNotify();
}


function createAnySoldOutNotify() {

  /*
   * Don't create twice.
   */
  if (productRoot.querySelector('.pp-any-oos-notify')) return;


  /*
   * Put it immediately below the variant picker.
   */
  const variantPicker =
    productRoot.querySelector('#variant-selects-' + productRoot.dataset.section) ||
    productRoot.querySelector('.pp-variant-picker')?.parentElement;

  if (!variantPicker) return;


  const wrapper = document.createElement('div');

  wrapper.className = 'pp-any-oos-notify';

  wrapper.innerHTML = `
    <button
      type="button"
      class="pp-any-oos-notify__button"
    >
      Varsle meg når varen er tilbake
    </button>

    <div
      class="pp-any-oos-notify__variants"
      hidden
    ></div>
  `;

  variantPicker.insertAdjacentElement('afterend', wrapper);


  const button =
    wrapper.querySelector('.pp-any-oos-notify__button');

  const variantList =
    wrapper.querySelector('.pp-any-oos-notify__variants');


  /*
   * ------------------------------------------------------
   * If only ONE variant is unavailable:
   *
   * Click Notify
   * → select that variant automatically
   * → open Kbite
   * ------------------------------------------------------
   */

  if (soldOutVariants.length === 1) {

    const soldOutVariant = soldOutVariants[0];

    button.addEventListener('click', function () {

      selectSoldOutVariant(soldOutVariant);

    });

    return;
  }


  /*
   * ------------------------------------------------------
   * If MULTIPLE variants are unavailable:
   *
   * Let the customer choose which one they want.
   * ------------------------------------------------------
   */

  soldOutVariants.forEach(function (variant) {

    const variantButton = document.createElement('button');

    variantButton.type = 'button';
    variantButton.className =
      'pp-any-oos-notify__variant';

    variantButton.textContent =
      variant.title;

    variantButton.addEventListener('click', function () {

      selectSoldOutVariant(variant);

    });

    variantList.appendChild(variantButton);

  });


  button.addEventListener('click', function () {

    variantList.hidden =
      !variantList.hidden;

  });

}


/*
 * ========================================================
 * SELECT THE SOLD-OUT PAGEPILOT VARIANT
 * ========================================================
 */

function selectSoldOutVariant(variant) {

  if (!variant) return;


  const optionGroups =
    productRoot.querySelectorAll('.pp-variant-picker');


  /*
   * Set every option belonging to this variant.
   *
   * Works for:
   * Flavor
   *
   * and also products such as:
   * Size + Color
   */

  variant.options.forEach(function (optionValue, index) {

    const group = optionGroups[index];

    if (!group) return;

    const radios =
      group.querySelectorAll(
        'input[type="radio"]'
      );

    const matchingRadio =
      Array.from(radios).find(function (radio) {
        return radio.value === optionValue;
      });

    if (matchingRadio) {

      matchingRadio.disabled = false;
      matchingRadio.checked = true;

    }

  });


  /*
   * Trigger PagePilot using the final option.
   */

  const finalGroup =
    optionGroups[
      Math.min(
        variant.options.length - 1,
        optionGroups.length - 1
      )
    ];

  const finalRadio =
    finalGroup?.querySelector(
      'input[type="radio"]:checked'
    );

  if (finalRadio) {

    finalRadio.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );

  }


  /*
   * Give PagePilot + Kbite a moment to react.
   */

  setTimeout(function () {

    openKbite();

  }, 250);

}


/*
 * ========================================================
 * FIND + OPEN KBITE
 * ========================================================
 */

function openKbite() {

  const selectors = [
    '[class*="cartbite"]',
    '[id*="cartbite"]',
    '[class*="kbite"]',
    '[id*="kbite"]'
  ];


  /*
   * Try known-ish app selectors first.
   */

  for (const selector of selectors) {

    const elements =
      document.querySelectorAll(selector);

    for (const element of elements) {

      if (
        element.closest('.pp-any-oos-notify')
      ) {
        continue;
      }

      const text =
        (element.textContent || '')
          .toLowerCase();

      if (
        text.includes('varsle') ||
        text.includes('notify')
      ) {

        element.click();
        return true;

      }

    }

  }


  /*
   * Kbite's tab may not contain kbite/cartbite
   * in its class name, so also search by text.
   */

  const elements =
    document.querySelectorAll(
      'button, a, div'
    );

  for (const element of elements) {

    if (
      element.closest('.pp-any-oos-notify')
    ) {
      continue;
    }

    const text =
      (element.textContent || '')
        .trim()
        .toLowerCase();

    if (
      text.includes(
        'varsle meg når varen er tilbake'
      ) ||
      text === 'notify me' ||
      text.includes('notify me when')
    ) {

      element.click();

      return true;

    }

  }


  /*
   * Kbite might inject the button a little later.
   */

  waitForKbite();

  return false;

}

});

